export const POLLING_INTERVAL = 300000;